export const SidebarRightActiveIcon = ({
  size = 16,
  color = 'currentColor',
  ...rest
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <rect x="15" y="4" width="5" height="16" fill="currentColor" />
  </svg>
);
